import React, { useState } from "react";
import AddCircle from '@mui/icons-material/AddCircleRounded';
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { InputGroup, Button, FormControl, Modal, Col, Row } from "react-bootstrap";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import DataGridBooking from './DataTable';

export const Booking = () => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <div className={`card card-custom`}>
                {/* Start Box Header */}
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            مدیریت سفارش ها
                        </span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">
                            لیست سفارش ها
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <Button variant="success" onClick={handleShow}>
                            <AddCircle className='mr-1' />
                             افزودن سفارش
                    </Button>
                    </div>
                </div>

                {/*Start body */}
                <div className="card-body pt-3 pb-0">

                    {/* search box */}
                    <div className='border-top pt-3'>
                        <InputGroup className="mb-3">
                            <FormControl aria-describedby="basic-addon1" placeholder='جستجو ...' />
                         
                                <Button variant="secondary"><SearchIcon /></Button>
                          
                        </InputGroup>
                    </div>

                    {/* table */}
                    <Col xs='12' className='tb-reponsive px-0'>
                        <DataGridBooking />
                    </Col>

                </div>

                {/* Start Modal */}
                <Modal centered size='md' show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>افزودن سفارش</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form noValidate autoComplete="off">
                            <Row>
                                <Col xs='12'>
                                    <TextField
                                        id="outlined-select-currency"
                                        select
                                        label="نام تفریح"
                                        className="w-100"
                                        variant="outlined" 
                                        size='small'>
                                        <MenuItem key='1' value='1'>جنگ شبانه رنگارنگ</MenuItem>
                                        <MenuItem key='1' value='1'>پاراسل</MenuItem>
                                        <MenuItem key='1' value='1'>شاتل</MenuItem>
                                        <MenuItem key='1' value='1'>فلای برد</MenuItem>

                                    </TextField>
                                </Col>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="نام"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="نام خانوادگی"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="شماره همراه"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="تاریخ استفاده از تفریح"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="تعداد بلیط"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                            </Row>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={handleClose}>
                            <SaveIcon />  ذخیره
                        </Button>
                        <Button variant="danger" onClick={handleClose}>
                            <CloseIcon />  بستن
                         </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}
